import {keycloakConfig} from './config';
import Keycloak, {KeycloakInitOptions} from 'keycloak-js'
import * as _ from "lodash";
import { Cookies } from 'react-cookie';

const urlParams = new URLSearchParams(window.location.search);
const clientId = urlParams.has('k_cl') ? urlParams.get('k_cl') as string : keycloakConfig.clientId

export let keycloak = new Keycloak({ ...keycloakConfig, clientId });

keycloak.onAuthRefreshError = () => {
  console.log('onAuthRefreshError');
  // it made infinite reload.
  // keycloak.logout();
};

keycloak.onTokenExpired = () => {
  keycloak.updateToken(10)
};

function setCookiesFromServer(token: string) {
  return new Promise<boolean>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${keycloakConfig.url}realms/${keycloakConfig.realm}/set-cookie-by-token`, true);
    xhr.setRequestHeader('authorization', 'Bearer ' + token);
    xhr.withCredentials = true;
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        const status = xhr.status;
        if (status === 0 || (status >= 200 && status < 400)) {
          // The request has been completed successfully
          resolve(true)
        } else {
          // Oh no! There has been an error with the request!
          reject(xhr.responseText)
        }
      }
    };
    xhr.send();
  })
}

async function addTokensToSessionStorageFromMagicLink() {
  const params = new URLSearchParams(document.location.search);

  if (params.has('key')) {
    const c = new Cookies();
    const clientKey = c.get('next-auth.clientKey');
    const username = c.get('next-auth.username');
    const url = `${keycloakConfig.url}realms/${keycloakConfig.realm}/protocol/openid-connect/token`
    try {
      const tokens = await fetch(url, {
        method: 'POST',
        body: new URLSearchParams({
          'grant_type': 'password',
          'client_id': clientId,
          'scope': 'openid',
          'emailKey': params.get('key') || '',
          clientKey,
          username
        }),
      }).then(r => r.json());
      sessionStorage.setItem('token', tokens.access_token);
      sessionStorage.setItem('refreshToken', tokens.refresh_token);
      sessionStorage.setItem('idToken', tokens.id_token);
      sessionStorage.setItem('clif', 'false');

      await setCookiesFromServer(tokens.access_token);
    } catch (e) {}
  }
}

export const initKeycloak = async (options: KeycloakInitOptions = {}, keycloakInstance?: Keycloak) => {
  if (keycloakInstance) {
    keycloak = keycloakInstance;
  }
  addTokensToSessionStorageFromUrl();

  await addTokensToSessionStorageFromMagicLink()

  await keycloak.init({
    token: sessionStorage.getItem('token') || undefined,
    refreshToken: sessionStorage.getItem('refreshToken') || undefined,
    idToken: sessionStorage.getItem('idToken') || undefined,
    onLoad: "check-sso",
    checkLoginIframe: sessionStorage.getItem('clif') !== 'false',
    silentCheckSsoRedirectUri: window.location.origin + window.location.pathname,
    ...options
  });

  (window as any).keycloak = keycloak;

  return keycloak;
}

export const initKeycloakIfAuthenticated = async (options: KeycloakInitOptions = {}) => {
  const value = await initKeycloak(options);

  if (value.authenticated) {
    (window as any).keycloak = value;
    return value;
  } else {
    keycloak = new Keycloak(keycloakConfig);
    (window as any).keycloak = keycloak;
    keycloak.onAuthRefreshError = () => {
      console.log('onAuthRefreshError');
      // it made infinite reload.
      // keycloak.logout();
    };

    keycloak.onTokenExpired = () => {
      keycloak.updateToken(10)
    };
    return keycloak;
  }
}

export const initKeycloakAndAuthorize = async (options: KeycloakInitOptions = {}) => {
  const value = await initKeycloak({ ...options, checkLoginIframe: false });

  const token = options.token || keycloak.token;

  if (!token) {
    throw new Error('Unable to initialize keycloak token');
  }

  await setCookiesFromServer(token);

  return value;
}

export const getHash = () => {
  if (keycloak.authenticated) {
    return `#at=${keycloak?.token}&rt=${keycloak?.refreshToken}&it=${keycloak?.idToken}`
  }
  return '';
}

export const getIsAdmin = (keycloak: Keycloak) => keycloak.hasRealmRole(KeycloakRoles.ROLE_ADMIN)
export const getIsCSR = (keycloak: Keycloak) => keycloak.hasRealmRole(KeycloakRoles.ROLE_CSR)
export const getIsAgent = (keycloak: Keycloak) => keycloak.hasRealmRole(KeycloakRoles.ROLE_ADMIN) && !keycloak.hasRealmRole(KeycloakRoles.ROLE_CSR) && !keycloak.hasRealmRole(KeycloakRoles.ROLE_AGENT_MANAGER) && !keycloak.hasRealmRole(KeycloakRoles.ROLE_TECH_STAFF) && !keycloak.hasRealmRole(KeycloakRoles.ROLE_SUPER_ADMIN)
export const getIsDeveloper = (keycloak: Keycloak) => keycloak.hasRealmRole(KeycloakRoles.ROLE_TECH_STAFF)
export const getIsAgentManager = (keycloak: Keycloak) => keycloak.hasRealmRole(KeycloakRoles.ROLE_AGENT_MANAGER)
export const getIsSuperAdmin = (keycloak: Keycloak) => keycloak.hasRealmRole(KeycloakRoles.ROLE_SUPER_ADMIN)

const addTokensToSessionStorageFromUrl = () => {
  if (isAuthInHash()) {
    const auth = _.fromPairs(document.location.hash.slice(1).split('&').map(v => v.split('=')));
    sessionStorage.setItem('token', auth.at);
    sessionStorage.setItem('refreshToken', auth.rt);
    sessionStorage.setItem('idToken', auth.it);

    if (auth.clif) {
      sessionStorage.setItem('clif', auth.clif);
    }

    window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
  }
}

const isAuthInHash = (): boolean => {
  return document.location.hash.indexOf('at=') >= 0 && document.location.hash.indexOf('rt=') >= 0 && document.location.hash.indexOf('it=') >= 0
}


export enum KeycloakRoles {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_ALFA = 'ROLE_ALFA',
  ROLE_TECH_STAFF = 'ROLE_TECH_STAFF',
  ROLE_CSR = 'ROLE_CSR',
  ROLE_AGENT_MANAGER = 'ROLE_AGENT_MANAGER',
  ROLE_ADVISER = 'ROLE_ADVISER',
  ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
}

export const getToken = () => {
  return new Promise<string | undefined>((resolve, reject) => {
    keycloak.updateToken(5)
      .then(() => {
        resolve(keycloak.token);
      })
      .catch((e: any) => {
        reject(e);
      })
  });
}

export const createLoginUrl = (redirectUri = document.location.href) => {
  return  `${keycloakConfig.url}realms/${keycloakConfig.realm}/protocol/openid-connect/auth?client_id=${keycloakConfig.clientId}&redirect_uri=${encodeURI(redirectUri)}&response_mode=fragment&response_type=code&scope=openid`
}
